import React from "react";
import useForm, { Form } from "../../../../hooks/useForm";
import { Grid } from "@mui/material";
import Controls from "../../../../components/form/controls/Controls";
import { validationChangePasswordInput } from "../../../../utils";
import { changePassword } from "../../../../apis/auth.api";

const initialValue = {
  password: "",
  newPassword: "",
  confirmPassword: "",
};

const EmployeeChangePassword = () => {
  // validation input change password
  const validateChangePasswordForm = (fieldValues = values) => {
    let temp = validationChangePasswordInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, errors, setErrors, handleInputChange, resetForm } = useForm(
    initialValue,
    true,
    validateChangePasswordForm
  );

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateChangePasswordForm()) {
      changePassword(values, (result) => {
        // callback nhận về lỗi form và thành công
        if (result.data?.status === 422) {
          setErrors({ ...result.data.data });
        } else {
          resetForm();
        }
      });
    }
  };
  return (
    <Form onSubmit={onSubmit}>
      <Grid container>
        <Grid item xs={6} p={5}>
          <Controls.Input
            name="password"
            value={values.password}
            label="Password"
            type="password"
            onChange={handleInputChange}
            error={errors.password}
          />
          <Controls.Input
            name="newPassword"
            value={values.newPassword}
            label="New Password"
            type="password"
            onChange={handleInputChange}
            error={errors.newPassword}
          />
          <Controls.Input
            name="confirmPassword"
            value={values.confirmPassword}
            label="Confirm Password"
            type="password"
            onChange={handleInputChange}
            error={errors.confirmPassword}
          />
          <div style={{ marginTop: "10px" }}>
            <Controls.Button type="submit" text="Submit" />
          </div>
        </Grid>
        <Grid item xs={6} p={5}>
          <div>
            <h2>CHANGE PASSWORD POLICY</h2>
          </div>
          <div style={{ marginTop: "10px" }}>
            <h3>Chứa các ký tự theo các yêu cầu sau:</h3>
            <h5>a. Chứa ít nhất 8 ký tự</h5>
            <h5>b. Ít nhất một ký tự tiếng Anh viết hoa (A - Z)</h5>
            <h5>c. Ít nhất một ký tự tiếng Anh viết thường (a -z)</h5>
            <h5>c. Ít nhất một ký tự số (0-9)</h5>
            <h5>
              e. Ít nhất một ký tự đặc biệt (ví dụ : ` ~ ! @ # $ % ^ & * ( ) _ +
              - = {} | \ " ; ' &lt; &gt; ? , . / )
            </h5>
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default EmployeeChangePassword;
